<template>
  <el-row>
    <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' :span="4" v-loading="loadingAssignedApplications">
      <applications-lane
        :assignedApplications="assignedApplications"
        :assignedApps="assignedApps">
      </applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
             <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                  v-if='workingApplication.degreeType === "bachelor" && workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="generalCommentInDocs"
                    :neededDocuments="workingApplication.neededDocuments">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <auditor-judgement
                    :application='workingApplication'
                    :attachedDocumentsTable="attachedDocumentsTable">
                  </auditor-judgement>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import ApplicationsLane from './common/ApplicationsLane'
import axios from 'axios'
import UserAppInfo from './common/UserAppInfo'
import sharedMethods from './common/sharedMethods.js'
import AuditorJudgement from './roleSpecific/AuditorJudgement'

export default {
  components: {
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    AuditorJudgement,
    UserAppInfo,
    ApplicationsLane
  },
  mixins: [sharedMethods],
  data () {
    return {
      appsToRelease: [],
      appsToAssign: [],
      role: 'auditor',
      tabPosition: 'top',
      activeName: 'fifth',
      myApplications: [],
      loadingAllApplications: false,
      assignedApps: {auditorW_: [{ id: '1', surname: '', createdAt: '', degreeType: '' }]}
    }
  },
  methods: {
    toggleApplication (app) {
      this.$store.dispatch('LOAD_WORKING_APPLICATION', app.id)
    },
    handleClick (tab, event) {
    },
    appsToReleaseChanged (apps) {
      this.appsToRelease = apps
    },
    appsToAssignChanged (apps) {
      this.appsToAssign = apps
    },
    fetchMyApplications () {
      this.loadingAllApplications = true
      axios.get(`${this.BASE_URL}/auditors/applications`)
        .then((response) => {
          this.myApplications = response.data.data
        }, (err) => {
          this.backendError(err)
        })
    }
  },
  computed: {
    generalCommentInDocs () {
      let comments = []
      let history = this.workingApplication.applicationHistory.slice(0)
      comments = history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment !== undefined &&
        history[history.length - 1].judgment.pendingReason !== null
        ? history
          .filter(step => step.applicationStatus === 'precheckerW_')
        : []
      return comments
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'history',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
      this.activeName = 'fifth'
    },
    assignedApplications: function (newData, oldData) {
      this.listAssignedApplications = this.assignedApplications
    }
  }
}
</script>

<style lang="scss">
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
div.el-transfer-panel {
  width: 350px
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auditor.vue